import { useEffect } from "react"

/**
 * Shows the native browser "Leave site?" dialog on refresh/close
 * when `when` is true. No custom UI, no router integration.
 */
export function useNativeLeaveConfirm(when: boolean, onLeave: () => void) {
  useEffect(() => {
    if (!when) return

    const onBeforeUnload = (e: BeforeUnloadEvent) => {
      try { onLeave() } catch {}
      // Required for modern browsers to trigger the native dialog:
      e.preventDefault()
      e.returnValue = "" // Chrome/Edge ignore custom text
    };

    window.addEventListener("beforeunload", onBeforeUnload)
    return () => window.removeEventListener("beforeunload", onBeforeUnload)
  }, [when])
}
